module.exports = __webpack_public_path__ + "img/banner_image3.a8439687.jpg";